"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetWhitelabelName = void 0;

var _get2 = _interopRequireDefault(require("lodash/get"));

var _useConstructorContextState = require("./useConstructorContextState");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var useGetWhitelabelName = function useGetWhitelabelName() {
  var state = (0, _useConstructorContextState.useConstructorContextState)();
  return (0, _get2["default"])(state, ['whitelabelName'], '');
};

exports.useGetWhitelabelName = useGetWhitelabelName;